import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ModalDialogService } from '../../modal-dialog';

@Component({
  selector: 'ins-modal2',
  templateUrl: './modal2.component.html',
  styleUrls: ['./modal2.component.scss'],
  animations: [
    trigger('modal2', [
      transition('void => *', [
        style({
          transform: 'scale(0)',
          opacity: 0,
        }),
        animate(
          '250ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({
            transform: 'scale(1)',
            opacity: 1,
          })
        ),
      ]),
      transition(
        '* => void',
        animate(
          '175ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({
            transform: 'scale(0)',
            opacity: 0,
          })
        )
      ),
    ]),
  ],
})
export class Modal2Component implements OnInit, AfterViewInit {
  @Input() size = 'medium'; //size can be default (small, medium) or custom pixels (50, 30) or percentage (70p)
  @Input() heightOptions = 'none';
  @Input() showXButton = false;
  @Input() ignoreClose = false;
  @Input() allowPropagation = false;
  @Input() zIndex = 0;
  @Input() transparentBackground = false;

  @ViewChild('container', { static: false }) container: ElementRef;
  @ViewChild('wrapper', { static: true }) wrapper: ElementRef;

  gridSize = '';
  heightClass = '';
  private gridClassPrefix = 'grid-';

  constructor(private _modalService: ModalDialogService, public el: ElementRef) {}

  ngAfterViewInit() {
    if (this.zIndex !== 0) {
      this.wrapper.nativeElement.style.zIndex = this.zIndex;
    }
  }

  ngOnInit(): void {
    this.el.nativeElement.querySelector('.focus').focus();
    switch (this.size) {
      case 'xsmall':
        this.gridSize = this.gridClassPrefix + '25';
        break;
      case 'discard-popUp':
        this.gridSize = this.gridClassPrefix + '35';
        break;
      case 'small':
        this.gridSize = this.gridClassPrefix + '40';
        break;
      case 'medium':
        this.gridSize = this.gridClassPrefix + '55';
        break;
      case 'large':
        this.gridSize = this.gridClassPrefix + '75';
        break;
      case 'info-panel':
        this.gridSize = this.gridClassPrefix + '75p';
        this.heightOptions = 'bottomDock';
        break;
      default:
        this.gridSize = this.gridClassPrefix + this.size;
    }

    switch (this.heightOptions) {
      case 'fullHeight':
        this.heightClass = 'full-height';
        break;
      case 'bottomDock':
        this.heightClass = 'bottom-dock';
        break;
      case 'reportsDock':
        this.heightClass = 'reports-dock';
        break;
      default:
        this.heightClass = '';
    }
  }

  close(): void {}

  stopEvent($event: MouseEvent): void {
    if (!this.allowPropagation) {
      $event.stopPropagation();
    }
  }
}
